import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataManager, ODataV4Adaptor } from '@syncfusion/ej2-data';
import { Observable } from 'rxjs/Observable';
import { Subscriber } from 'rxjs/Subscriber';
import { global } from '../../../app.settings';
import { CodeNamePair } from '../../model/code-name-pair.model';
import { ClaimService } from '../../claim.service';

@Injectable()
export class SearchFilterService {
  private _lossStatuses: CodeNamePair[];
  private _searchOperators: CodeNamePair[];

  public get lossStatuses(): CodeNamePair[] {
    return this._lossStatuses;
  }

  public get searchOperators(): CodeNamePair[] {
    return this._searchOperators;
  }

  constructor(
    private http: HttpClient,
    private claimService: ClaimService
  ) {
  }

  public getLossStatuses(): Observable<CodeNamePair[]> {
    if (this._lossStatuses) {
      return Observable.create((observer: Subscriber<CodeNamePair[]>) => {
        observer.next(this._lossStatuses);
        observer.complete();
      });
    } else {
      return new Observable(observer => {
        this.http.get<CodeNamePair[]>(global.apiUrl + 'search/filters/loss-statuses').subscribe(
          lossStatuses => {
            this._lossStatuses = lossStatuses;
            observer.next(this._lossStatuses);
            observer.complete();
          });
      });
    }
  }

  public getSearchFilterHandlers(claimSource: string): DataManager {
    const adaptor = new ODataV4Adaptor();
    adaptor.beforeSend = (dm, req) => {
      req.withCredentials = true;
    };

    return new DataManager({
      url: global.apiUrl + 'search/filters/handlers?source=' + this.getClaimDataSource(claimSource),
      adaptor: adaptor
    });
  }

  public getSearchOperators(): Observable<CodeNamePair[]> {
    if (this._searchOperators) {
      return Observable.create((observer: Subscriber<CodeNamePair[]>) => {
        observer.next(this._searchOperators);
        observer.complete();
      });
    } else {
      return new Observable(observer => {
        this.http.get<CodeNamePair[]>(global.apiUrl + 'search/filters/operators').subscribe(
          searchOperators => {
            this._searchOperators = searchOperators;
            observer.next(this._searchOperators);
            observer.complete();
          });
      });
    }
  }

  public getSearchFilterInsurers(claimSource: string): Observable<any> {
    return this.http.get<any>(global.apiUrl + 'search/filters/insurers?source=' + this.getClaimDataSource(claimSource));
  }

  public getSearchFilterBrokers(claimSource: string): Observable<any> {
    return this.http.get<any>(global.apiUrl + 'search/filters/brokers?source=' + this.getClaimDataSource(claimSource));
  }

  public getSearchFilterClientAccounts(claimSource: string): Observable<any> {
    return this.http.get<any>(global.apiUrl + 'search/filters/client-accounts?source=' + this.getClaimDataSource(claimSource));
  }

  public getSearchFilterClasses(claimSource: string): Observable<any> {
    return this.http.get<any>(global.apiUrl + 'search/filters/classifications?source=' + this.getClaimDataSource(claimSource));
  }

  public getSearchFilterProducts(claimSource: string): Observable<any> {
    return this.http.get<any>(global.apiUrl + 'search/filters/products?source=' + this.getClaimDataSource(claimSource));
  }

  private getClaimDataSource(source: string): string {
    if (source || !this.claimService.claimDataSourceName) {
      return source;
    } else {
      return this.claimService.claimDataSourceName;
    }
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/UI/src/app/claim/claim-list/services/search-filter.service.ts